import { icons } from "../assets/icons/icons";
import { ContainerShape, HexagonShape, InnerShape } from "../components/Shape";
import { useSound } from "../components/SoundHandler";
import { BlinkoGame } from "../api";
import { useNavigate } from "react-router-dom";
import { useToast } from "~/core/contexts/ToastContext";
import { useAtomValue } from "jotai";
import { atomGameState } from "../states/game.atoms";

export const ContinueModal = ({ game, onDismiss }: { game: BlinkoGame, onDismiss: () => void }) => {
  const sounds = useSound();
  const navigate = useNavigate()
  const toast = useToast()

  const gameState = useAtomValue(atomGameState);

  const onClose = () => {
    onDismiss();
    sounds.play('click');
  };

  const onContinue = async () => {
    if (gameState !== 'waiting') {
      toast.error('You can only continue when no game is in progress');
      onClose();
      return;
    }
    sounds.play('click');
    navigate(`/?gameId=${game.gameId}`, { replace: true })
    onClose();
  };

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-[#18181B]/50">
      <div>
        <ContainerShape cornerDiagonal={20} cornerRadius={8} strokeWidth={2} >
          <div className="p-6 w-[350px] md:w-[448px]">
            <div className="flex flex-row justify-between items-start">
              <div className="mt-1 text-2xl font-black text-white font-blinko">
                Ongoing Game Found!
              </div>
              <button
                onClick={onClose}
                className=""
              >
                <HexagonShape cornerRadius={6} strokeWidth={1}>
                  <div className="flex justify-center items-center p-2">
                    <img src={icons.close} className="w-6 h-6" />
                  </div>
                </HexagonShape>
              </button>
            </div>
            <p className="text-sm text-white/70 mt-3">
              Do you want to continue playing?
            </p>

            <div className="mt-6 flex justify-end space-x-2">
              <button onClick={onContinue}>
                <InnerShape cornerDiagonal={14} cornerRadius={8} strokeWidth={1}>
                  <div className="relative px-6 py-3">
                    <p className="text-sm font-medium text-white font-blinko">
                      Continue
                    </p>
                  </div>
                </InnerShape>
              </button>
            </div>
          </div>
        </ContainerShape>
      </div>
    </div>
  );
};


